import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/msalConfig';
import './Login.css';

export default function Login() {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  const handleLogin = async () => {
    setIsLoading(true);
    setError('');
    try {
      // loginRedirect (full-page navigation) instead of loginPopup. Popup
      // flow is fragile under modern Cross-Origin-Opener-Policy: when the
      // popup navigates to login.microsoftonline.com (which sets strict
      // COOP), the browser severs the opener-popup relationship, so the
      // parent window can never read the auth response back from the
      // popup. The redirect flow has no popup and no COOP issues — the
      // whole window navigates to Microsoft and back.
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      setError('Failed to login. Please try again.');
      console.error('Login error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>SwishIQ</h1>
          <h2>Management System</h2>
        </div>

        <div className="login-content">
          <p className="login-subtitle">Sign in to manage games and assignments</p>

          {error && <div className="error-message">{error}</div>}

          <button
            onClick={handleLogin}
            disabled={isLoading}
            className="login-button microsoft-button"
          >
            {isLoading ? 'Signing in...' : '🔐 Sign in with Microsoft'}
          </button>

          <p className="login-footer">
            Use your Microsoft account or organizational account to sign in
          </p>
        </div>

      </div>
    </div>
  );
}
